import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const UnlockCelebration = ({ data }) => {
  useEffect(() => {
    // Trigger confetti animation
    const timer = setTimeout(() => {
      // Animation cleanup
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-in fade-in duration-300">
      <div className="bg-gradient-to-br from-blue-500 via-purple-600 to-pink-500 rounded-2xl p-8 max-w-md w-full text-center shadow-2xl animate-in zoom-in duration-500">
        {/* Animated Icon */}
        <div className="relative mb-6">
          <div className="w-24 h-24 mx-auto rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center border-4 border-white/40 animate-bounce">
            <Icon name={data?.icon} size={48} className="text-white" />
          </div>
          {/* Sparkle Effects */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-4">
            <Icon name="Sparkles" size={24} className="text-amber-300 animate-pulse" />
          </div>
          <div className="absolute bottom-0 left-1/4 translate-y-4">
            <Icon name="Star" size={20} className="text-yellow-300 animate-ping" />
          </div>
          <div className="absolute bottom-0 right-1/4 translate-y-4">
            <Icon name="Star" size={20} className="text-yellow-300 animate-ping" style={{ animationDelay: '0.2s' }} />
          </div>
        </div>

        {/* Celebration Text */}
        <h2 className="text-3xl font-bold text-white mb-3">
          🎉 Félicitations !
        </h2>
        <p className="text-xl text-white/90 mb-2">
          Domaine Débloqué
        </p>
        <p className="text-2xl font-bold text-white mb-6">
          {data?.fieldName}
        </p>

        {/* Reward Display */}
        <div className="bg-white/20 backdrop-blur-md rounded-xl p-5 border border-white/30 mb-6">
          <div className="flex items-center justify-center gap-3">
            <Icon name="Award" size={32} className="text-amber-300" />
            <div className="text-left">
              <p className="text-sm text-white/80">Récompense</p>
              <p className="text-3xl font-bold text-white">+{data?.rewardPoints} Points</p>
            </div>
          </div>
        </div>

        {/* Encouragement */}
        <p className="text-white/80 text-sm">
          Continuez à explorer pour débloquer plus de contenu exclusif !
        </p>
      </div>
    </div>
  );
};

export default UnlockCelebration;